/* The Aina Sunday Set — PDP buy box behaviour (snippets/afroyla-sunday-set-box.liquid).
 *
 * 1. Arrival window: "On your arm by <d1> – <d2>" computed from today —
 *    leaves the warehouse within 2 business days (truth T4.2), then 2–8
 *    business days in transit (T4.3). Business days = Mon–Fri. Printed as
 *    "Sep 16 – Sep 24"; never a countdown, never "today".
 * 2. The button: the three lines go through the Cart API with the line
 *    property `_afl_lp` = data-lp-key AND the cart attribute of the same
 *    name, then stays on the page and lets the theme open the cart drawer
 *    (owner 10.09: a normal add-to-cart, no /checkout redirect) — the afl-set-discount function prices
 *    the three lines as one set only when both are present (config
 *    afl-aina-sunday-set.json, require_attr.lines). The cart is NOT cleared
 *    (this is a product page, not a landing page); other lines keep their
 *    own prices. A permalink is never used — it cannot carry line properties.
 * 3. Failure: message under the button, button re-enabled, no redirect
 *    (a redirect would check out at list price). */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /** date + n business days (Mon–Fri), same time of day. */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  }

  function fmt(d) {
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function paintArrival(root) {
    var outs = root.querySelectorAll('[data-afl-sset-dates]'); // 23.09: the hidden twin timeline is painted too
    if (!outs.length) return;
    var now = new Date();
    var ships = addBusinessDays(now, 2);
    var first = addBusinessDays(ships, 2);
    var last = addBusinessDays(ships, 8);
    for (var i = 0; i < outs.length; i += 1) outs[i].textContent = fmt(first) + ' – ' + fmt(last);
    var shipOuts = root.querySelectorAll('[data-afl-sset-ships]'); // v4 timeline step 2
    for (var j = 0; j < shipOuts.length; j += 1) shipOuts[j].textContent = fmt(ships);
  }

  /* 23.09 - COLOUR + SIZE + LEATHER, in place (owner 17:04 / 17:16: no load, no jump, for every option).
     One state { colour, size, leather } over the options island (snippets/afroyla-sunday-set-options-island):
       colours[handle] = { name, url, thumb, hero, eyebrow, h1, sub, images[], sizes: { Medium: { lp, url, dims, thumb, pack, variants: { "Vegan leather": {…} } } } }
     Rows: colour radios valued by handle (afroyla-sunday-set-colour-row), size radios by size name (…-size-row), leather radios by
     leather name (…-leather-row). The active variant = colours[colour].sizes[size].variants[leather] (with fallbacks when a colour
     lacks that size / leather). A tap repaints every number on the page from that entry (offer card, chips, deadline "then $…",
     bag row dims / thumb / prices, the bag's View-details sheet, CTA, phone sticky bar, closing band, gallery set tag, the three
     rows' own prices and states), swaps the bag's variant id in data-items and the gate in data-lp-key (both read at click time
     by wireButton), shows the timeline that matches the ship window, re-points the GALLERY to the colour's own photos (panes by
     sequence token; a photo the colour lacks hides its pane + thumb; banner / close panes show only for a colour that has one),
     swaps the per-colour eyebrow / headline / sub when the template maps them, and rewrites the URL (replaceState) to the real
     product page + ?variant=. No fetch, no navigation, no scroll. A ?variant= on load that matches this page's product is honoured. */
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function moneyShort(cents) { return cents % 100 === 0 ? '$' + (cents / 100) : money(cents); }
  function setAll(sel, text) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i += 1) els[i].textContent = text;
  }
  function stateText(v) { return !v.avail ? 'Sold out' : v.window ? 'Ships ' + v.window : 'In stock'; }
  function parseIsland(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_e) { return null; }
  }
  function wireOptions(root) {
    var tree = parseIsland(root.querySelector('[data-afl-sset-options]'));
    if (!tree || !tree.colours) return;
    var cRadios = root.querySelectorAll('[data-afl-sset-colour-opt]');
    var sRadios = root.querySelectorAll('[data-afl-sset-size-opt]');
    var lRadios = root.querySelectorAll('[data-afl-sset-leather-opt]');
    var checked = function (list) { for (var i = 0; i < list.length; i += 1) if (list[i].checked) return list[i].value; return ''; };
    // 12.10 (owner: every appliqué-backpack ad lands on ONE page): ?d=<handle fragment> pre-selects that design's tile, so a
    // Rembo ad opens on Rembo while the page's own product stays the default when the param is absent or unknown.
    var wantDesign = '';
    try { wantDesign = (new URL(window.location.href).searchParams.get('d') || '').toLowerCase(); } catch (_e) { wantDesign = ''; }
    function pickRadio(w) { for (var w2 = 0; w2 < cRadios.length; w2 += 1) cRadios[w2].checked = (w2 === w); }
    function tileName(h) { return String(((tree.colours[h] || {}).name) || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    var picked = false;
    if (wantDesign) {
      // #742 order: (1) the TILE NAME equals ?d= ("red" → Red, not Oxblood Red whose handle also contains "red";
      // "black" → the tile named Black even though its handle reads safiya-blabk-…), (2) the handle contains it
      // (cobalt → serwa-cobalt-blue-…, the 12.10 rule), (3) the name contains it. Ad links stay exactly as they are.
      var wantName = wantDesign.replace(/[^a-z0-9]/g, '');
      for (var we = 0; we < cRadios.length && !picked && wantName; we += 1) {
        if (tileName(cRadios[we].value) === wantName) { pickRadio(we); picked = true; }
      }
      for (var w = 0; w < cRadios.length && !picked; w += 1) {
        if (String(cRadios[w].value).toLowerCase().indexOf(wantDesign) !== -1) { pickRadio(w); picked = true; }
      }
      for (var wn = 0; wn < cRadios.length && !picked && wantName; wn += 1) {
        if (tileName(cRadios[wn].value).indexOf(wantName) !== -1) { pickRadio(wn); picked = true; }
      }
    }
    // #742: no ?d= on the link, but the ad NAME travels in utm_content ({{ad.name}} in every Meta url_tags) and the colour
    // ads are named Serwa02_static_FlatlayUGC_Black_An / …AdaezeNavyBlue_An. When the template opts in (ad_name_colour_match),
    // a word-style ad name (no spaces / pipes) whose words contain a tile's name picks that tile — "Black" followed by
    // "owned" is the audience, not the colour, and is skipped. Human-titled ads ("SERWA-SET | S1 …") never match.
    if (!picked && tree.adColour) {
      var adName = '';
      try { adName = new URL(window.location.href).searchParams.get('utm_content') || ''; } catch (_e) { adName = ''; }
      if (adName && !/[\s|]/.test(adName)) {
        var words = adName.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
        // a tile matches by its whole name ("oxblood red") or by its first word ("oxblood", "navy"); the longest match
        // wins ("…OxbloodRed" → Oxblood Red, not Red), a colour tile beats the page's own tile (its name is the design,
        // "…AdaezeBrown_An" → Brown), then the earliest in the name
        var best = -1, bestLen = 0, bestAt = 1e9, bestOwn = true;
        function seqAt(seq) {
          for (var wi = 0; wi + seq.length <= words.length; wi += 1) {
            var ok = true;
            for (var ni = 0; ni < seq.length && ok; ni += 1) ok = words[wi + ni] === seq[ni];
            if (ok && words[wi + seq.length] !== 'owned') return wi;
          }
          return -1;
        }
        for (var ci = 0; ci < cRadios.length; ci += 1) {
          var nameWords = String(((tree.colours[cRadios[ci].value] || {}).name) || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
          if (!nameWords.length) continue;
          var tries = nameWords.length > 1 ? [nameWords, [nameWords[0]]] : [nameWords];
          var isOwn = String(cRadios[ci].value) === String(tree.own);
          for (var ti = 0; ti < tries.length; ti += 1) {
            var at = seqAt(tries[ti]);
            if (at < 0) continue;
            var better = tries[ti].length > bestLen ||
              (tries[ti].length === bestLen && ((bestOwn && !isOwn) || (bestOwn === isOwn && at < bestAt)));
            if (better) { best = ci; bestLen = tries[ti].length; bestAt = at; bestOwn = isOwn; }
          }
        }
        if (best >= 0) { pickRadio(best); picked = true; }
      }
    }
    var state = { colour: checked(cRadios) || tree.own, size: checked(sRadios), leather: checked(lRadios) };
    var painted = { gallery: tree.own + '|' + tree.own };
    function colourEntry() { return tree.colours[state.colour] || tree.colours[tree.own]; }
    function sizeEntry(c) {
      c = c || colourEntry();
      if (!c || !c.sizes) return null;
      if (c.sizes[state.size]) return c.sizes[state.size];
      var keys = Object.keys(c.sizes);
      return keys.length ? c.sizes[keys[0]] : null;
    }
    function variantOf(se, leather) {
      if (!se || !se.variants) return null;
      var vs = se.variants;
      return vs[leather] || vs['default'] || vs[Object.keys(vs)[0]] || null;
    }
    function viewSuffix() {
      try { return new URL(window.location.href).searchParams.get('view') || ''; } catch (_e) { return ''; }
    }
    function setRadios(list, value) {
      for (var i = 0; i < list.length; i += 1) list[i].checked = String(list[i].value) === String(value);
    }
    function paintGallery(c, se) {
      var gal = document.querySelector('[data-afl-sgal]');
      if (!gal) return;
      // the size product's own photos when it has them (owner 17:29), else the colour's
      var images = (se && se.images && se.images.length) ? se.images : (c.images || []);
      var isOwn = c.handle === tree.own && (!se || se.handle === tree.own);
      // the page's curated sequence (2,4,5,9,3,8…) was written for its own photo set; a product with a different set
      // (the Small bags: 7 mockups vs 11 shots) fills the numeric panes in natural order so none of its photos is skipped
      var ownImages = ((tree.colours[tree.own] || {}).images) || [];
      var natural = !isOwn && images.length !== ownImages.length;
      var next = 0;
      var panes = gal.querySelectorAll('[data-afl-sgal-pane]');
      var thumbs = gal.querySelectorAll('[data-afl-sgal-thumb]');
      function forTok(list, tok) { for (var i = 0; i < list.length; i += 1) if (list[i].getAttribute('data-afl-sgal-tok') === tok) return list[i]; return null; }
      for (var i = 0; i < panes.length; i += 1) {
        var tok = panes[i].getAttribute('data-afl-sgal-tok') || '';
        var img = panes[i].querySelector('img.afl-sgal__img');
        var thumb = forTok(thumbs, tok);
        var thumbImg = thumb ? thumb.querySelector('img') : null;
        var show = true;
        if (tok === 'banner') {
          // the island already resolved the banner per colour (mapped banner, or the template's for hero_for_handle's product);
          // a size sibling shares its colour's banner only when it is that same product
          var hero = (se && se.handle !== c.handle) ? '' : (c.hero || '');
          if (hero) { if (img) { img.src = hero; img.removeAttribute('srcset'); } if (thumbImg) thumbImg.src = hero; }
          else show = false;
        } else if (tok === 'banner2' && panes[i].hasAttribute('data-afl-sgal-mapped')) {
          // #742: a per-design second banner (banner2_image_by_handle — the Appliqué stitch close-up) follows the tile;
          // a design without one (Kora) keeps the pane hidden
          var b2 = (se && se.handle !== c.handle) ? '' : (c.banner2 || '');
          if (b2) { if (img) { img.src = b2; img.removeAttribute('srcset'); } if (thumbImg) thumbImg.src = b2; }
          else show = false;
        } else if (tok === 'close' || tok === 'banner2') {
          show = !!c.renders && (!se || se.handle === c.handle); // renders made for one product only
        } else if (tok === 'set') {
          var bag = panes[i].querySelector('[data-afl-sgal-set-bag]');
          if (bag && se && se.pack) bag.src = se.pack;
          if (thumbImg && se && se.thumb) thumbImg.src = se.thumb;
        } else {
          var n = parseInt(tok, 10);
          var im = natural ? images[next++] : (n > 0 ? images[n - 1] : null);
          if (im && img) {
            // one CDN url per photo in the island (width=900); the 2x and thumb sizes are the same url at another width
            img.src = im.s;
            img.srcset = im.s + ' 1x, ' + im.s.replace('width=900', 'width=1320') + ' 2x';
            img.alt = im.a || '';
            if (thumbImg) thumbImg.src = im.s.replace('width=900', 'width=160');
          } else show = false;
        }
        panes[i].hidden = !show;
        if (thumb) thumb.hidden = !show;
      }
      if (typeof gal.__aflSgalRefresh === 'function') gal.__aflSgalRefresh();
    }
    function paint() {
      var c = colourEntry();
      var se = sizeEntry(c);
      if (!c || !se) return;
      // 17.10 (#409 bag switch page): show the chosen bag's own blocks (per-bag lines, proof wall, the details / reviews /
      // close sections rendered once per bag) and hand its "View details" sheet the n=1 slot the sheet shell opens
      var fors = document.querySelectorAll('[data-afl-sset-for]');
      for (var fi = 0; fi < fors.length; fi += 1) {
        var fon = fors[fi].getAttribute('data-afl-sset-for') === c.handle;
        fors[fi].hidden = !fon;
        var fid = fors[fi].getAttribute('data-afl-sset-id');
        if (fid) { if (fon) fors[fi].id = fid; else if (fors[fi].id === fid) fors[fi].removeAttribute('id'); }
      }
      var bagSheets = root.querySelectorAll('template[data-afl-sset-sheet-for]');
      for (var bi = 0; bi < bagSheets.length; bi += 1) {
        bagSheets[bi].setAttribute('data-sset-sheet', bagSheets[bi].getAttribute('data-afl-sset-sheet-for') === c.handle ? '1' : '1-off');
      }
      if (!se.variants || !se.variants[state.leather]) {
        // this colour / size lacks the chosen leather: take what it has and reflect it in the row
        var v0 = variantOf(se, state.leather);
        if (!v0) return;
        for (var nm in se.variants) if (Object.prototype.hasOwnProperty.call(se.variants, nm) && se.variants[nm] === v0) state.leather = nm;
        setRadios(lRadios, state.leather);
      }
      if (!c.sizes[state.size]) {
        for (var sk in c.sizes) if (Object.prototype.hasOwnProperty.call(c.sizes, sk) && c.sizes[sk] === se) state.size = sk;
        setRadios(sRadios, state.size);
      }
      var v = se.variants[state.leather];
      setAll('[data-afl-sset-setprice]', money(v.set));
      setAll('[data-afl-sset-was]', money(v.value));
      setAll('[data-afl-sset-off]', moneyShort(v.off));
      setAll('[data-afl-sset-list]', money(v.price));
      setAll('[data-afl-sset-reward]', money(v.value - v.set));
      var ship = root.querySelector('[data-afl-sset-p1-ship]');
      if (ship) {
        ship.textContent = v.window ? 'Ships ' + v.window : ship.getAttribute('data-afl-sset-ship-now') || 'In stock';
        ship.classList.toggle('is-pre', !!v.window);
        ship.classList.toggle('is-now', !v.window);
      }
      if (se.dims) setAll('[data-afl-sset-p1-dims]', se.dims);
      var thumb = root.querySelector('[data-afl-sset-p1-thumb]');
      if (thumb && se.thumb && thumb.getAttribute('src') !== se.thumb) thumb.setAttribute('src', se.thumb);
      var tpl = root.querySelector('template[data-sset-sheet="1"]');
      if (tpl && tpl.content) {
        var eyebrow = tpl.content.querySelector('.afl-sheet__eyebrow');
        if (eyebrow) eyebrow.textContent = moneyShort(v.off) + ' off with the set';
        var sizeLi = tpl.content.querySelector('[data-afl-sheet-size]');
        if (sizeLi && se.dims) sizeLi.textContent = se.dims;
        var hero = tpl.content.querySelector('.afl-sheet__hero');
        if (hero && se.pack) hero.src = se.pack;
      }
      var want = v.window ? 'pre' : 'now';
      var tls = document.querySelectorAll('[data-afl-sset-tl]');
      for (var i = 0; i < tls.length; i += 1) tls[i].hidden = tls[i].getAttribute('data-afl-sset-tl') !== want;
      setAll('[data-afl-sset-window]', v.window || '');
      paintArrival(root);
      // per-colour copy: the template's mapped line when it has one, else the page's own line with the own colour
      // name swapped for the chosen one ("Aina in Coconut White" → "Aina in Flame Red"); the row label too
      var ownName = (tree.colours[tree.own] || {}).name || '';
      function colourCopy(sel, mapped) {
        var el = document.querySelector(sel);
        if (!el) return;
        if (el.__aflOrig == null) el.__aflOrig = el.textContent;
        if (mapped) el.textContent = mapped;
        else if (ownName && c.name) el.textContent = el.__aflOrig.split(ownName).join(c.name);
      }
      colourCopy('[data-afl-sset-eyebrow]', c.eyebrow);
      colourCopy('[data-afl-sset-h1]', c.h1);
      colourCopy('[data-afl-sset-sub]', c.sub);
      colourCopy('[data-afl-sset-p1-note]', '');
      var cname = root.querySelector('[data-afl-sset-colour-name]');
      if (cname && c.name) cname.textContent = c.name;
      // the FREE pieces follow the colour (its own wallet / mini when it has them): rows, chip, sheets, set pane
      var pieces = [c.wallet, c.mini];
      var freeCents = 0;
      for (var pi = 0; pi < pieces.length; pi += 1) {
        var pc = pieces[pi];
        if (!pc) continue;
        var pn = pi + 2;
        freeCents += pc.price || 0;
        var pThumb = root.querySelector('[data-afl-sset-p' + pn + '-thumb]');
        if (pThumb && pc.thumb && pThumb.getAttribute('src') !== pc.thumb) pThumb.setAttribute('src', pc.thumb);
        var pList = root.querySelector('[data-afl-sset-p' + pn + '-list]');
        if (pList) pList.textContent = money(pc.price);
        var pShip = root.querySelector('[data-afl-sset-p' + pn + '-ship]');
        if (pShip) {
          pShip.textContent = pc.window ? 'Ships ' + pc.window : pShip.getAttribute('data-afl-sset-ship-now') || 'In stock';
          pShip.classList.toggle('is-pre', !!pc.window);
          pShip.classList.toggle('is-now', !pc.window);
        }
        var pTpl = root.querySelector('template[data-sset-sheet="' + pn + '"]');
        if (pTpl && pTpl.content) {
          var pHero = pTpl.content.querySelector('.afl-sheet__hero');
          if (pHero && pc.pack) pHero.src = pc.pack;
          var pTitle = pTpl.content.querySelector('.afl-sheet__title');
          if (pTitle && pc.name) pTitle.textContent = pc.name;
          var pEyebrow = pTpl.content.querySelector('.afl-sheet__eyebrow');
          if (pEyebrow) pEyebrow.textContent = pEyebrow.textContent.replace(/\$\d+(?:\.\d{2})?(?= sold apart)/, money(pc.price));
        }
        var galPic = document.querySelector(pi === 0 ? '[data-afl-sgal-set-wallet]' : '[data-afl-sgal-set-mini]');
        if (galPic && pc.pack) galPic.src = pc.pack;
      }
      if (freeCents) setAll('[data-afl-sset-free]', money(freeCents));
      // the cart add: this size's gate + this variant's id + this colour's pieces
      if (se.lp) root.setAttribute('data-lp-key', se.lp);
      var items;
      try { items = JSON.parse(root.getAttribute('data-items') || '[]'); } catch (_e) { items = []; }
      if (items[0]) items[0].id = v.id;
      if (items[1] && c.wallet && c.wallet.id) items[1].id = c.wallet.id;
      if (items[2] && c.mini && c.mini.id) items[2].id = c.mini.id;
      if (items.length) root.setAttribute('data-items', JSON.stringify(items));
      // rows: colour ring · size prices / states for this colour + leather · leather prices / states for this colour + size
      for (var ci = 0; ci < cRadios.length; ci += 1) {
        var cl = cRadios[ci].closest('label');
        if (cl) cl.classList.toggle('is-current', cRadios[ci].value === state.colour);
      }
      for (var si = 0; si < sRadios.length; si += 1) {
        var sl = sRadios[si].closest('label');
        var sEntry = c.sizes[sRadios[si].value];
        if (!sl) continue;
        sl.classList.toggle('is-current', sRadios[si].value === state.size);
        var sv = sEntry ? variantOf(sEntry, state.leather) : null;
        var sSet = sl.querySelector('[data-afl-sset-sopt-set]');
        var sState = sl.querySelector('[data-afl-sset-sopt-state]');
        var sDims = sl.querySelector('[data-afl-sset-sopt-dims]');
        if (sv) {
          if (sSet) sSet.textContent = money(sv.set);
          if (sState) { sState.textContent = stateText(sv); sState.className = 'afl-sset__size-state ' + (!sv.avail ? 'is-off' : sv.window ? 'is-pre' : 'is-instock'); }
          if (sDims && sEntry.dims) sDims.textContent = sEntry.dims;
        } else if (sState) { sState.textContent = 'Not in this colour'; sState.className = 'afl-sset__size-state is-off'; }
        var sOff = !sv || !sv.avail;
        sl.classList.toggle('is-off', sOff);
        sRadios[si].disabled = sOff;
      }
      for (var li = 0; li < lRadios.length; li += 1) {
        var ll = lRadios[li].closest('label');
        var lv = se.variants[lRadios[li].value];
        if (!ll) continue;
        ll.classList.toggle('is-current', lRadios[li].value === state.leather);
        var lList = ll.querySelector('[data-afl-sset-lopt-list]');
        var lSet = ll.querySelector('[data-afl-sset-lopt-set]');
        var lState = ll.querySelector('[data-afl-sset-lopt-state]');
        if (lv) {
          if (lList) lList.textContent = money(lv.price);
          if (lSet) lSet.textContent = money(lv.set);
          if (lState) { lState.textContent = stateText(lv); lState.classList.toggle('is-instock', !!lv.avail && !lv.window); }
        } else if (lState) { lState.textContent = 'Not in this size'; lState.classList.remove('is-instock'); }
        var lOff = !lv || !lv.avail;
        ll.classList.toggle('is-off', lOff);
        lRadios[li].disabled = lOff;
      }
      // sold-out combination: the button says so, the sticky bar hides (wireSticky reads the attribute)
      var cta = root.querySelector('[data-afl-sset-cta]');
      if (cta) {
        var lbl = cta.querySelector('.afl-sset__cta-text');
        if (!v.avail) {
          cta.disabled = true;
          cta.setAttribute('data-afl-sset-unavailable', '');
          if (lbl) { if (!cta.__aflCtaLabel) cta.__aflCtaLabel = lbl.textContent; lbl.textContent = 'Sold out'; }
        } else if (cta.hasAttribute('data-afl-sset-unavailable') && cta.__aflCtaLabel) {
          cta.disabled = false;
          cta.removeAttribute('data-afl-sset-unavailable');
          if (lbl) lbl.textContent = cta.__aflCtaLabel;
        }
      }
      // 17.10 (#422, owner): every buy button (CTA, phone sticky, close-band proxy) says 'Pre-order' while the chosen
      // bag ships on pre-order, and goes back to its own label when she picks an in-stock bag. The idle label the
      // add-state machine restores (b.__aflLabel) follows, so 'Adding…' / 'Added ✓' settle on the right verb.
      var verbBtns = [cta].concat([].slice.call(document.querySelectorAll('[data-afl-sset-sticky-btn], [data-afl-sset-cta-proxy]')));
      for (var vb = 0; vb < verbBtns.length; vb += 1) {
        var vbtn = verbBtns[vb];
        if (!vbtn) continue;
        var vlbl = vbtn.querySelector('[data-afl-sset-label], .afl-sset__cta-text');
        if (!vlbl) continue;
        if (vbtn.__aflIdle0 == null) vbtn.__aflIdle0 = vbtn.__aflLabel || vbtn.__aflCtaLabel || vlbl.textContent;
        var idle = v.window ? 'Pre-order' : vbtn.__aflIdle0;
        vbtn.__aflLabel = idle;
        if (vbtn === cta) cta.__aflCtaLabel = idle;
        if (v.avail && !vbtn.classList.contains('is-busy') && !vbtn.classList.contains('is-added')) vlbl.textContent = idle;
      }
      // the gallery follows the colour AND the size (once per change)
      var galKey = c.handle + '|' + se.handle;
      if (painted.gallery !== galKey) { paintGallery(c, se); painted.gallery = galKey; }
      // the URL = the real product page (+ the template view) + the variant, so reload / share land on it.
      // 30.09 (owner: "phần chọn color đang link về pdp"): on a /pages/<x>-set ad landing page the URL is NEVER rewritten —
      // the ad visitor stays on the offer page (its gate + tests); only product templates follow the chosen colour.
      if (window.location.pathname.indexOf('/pages/') === 0) {
        document.dispatchEvent(new CustomEvent('afl:sset:variant', { bubbles: true, detail: { colour: c, size: se, variant: v, name: state.leather } }));
        return;
      }
      try {
        var u = new URL(window.location.href);
        if (se.url) u.pathname = se.url;
        var view = viewSuffix();
        if (view) u.searchParams.set('view', view);
        u.searchParams.set('variant', String(v.id));
        window.history.replaceState(null, '', u.toString());
      } catch (_e) { /* no URL API: the page still works, the link just does not carry the choice */ }
      document.dispatchEvent(new CustomEvent('afl:sset:variant', { bubbles: true, detail: { colour: c, size: se, variant: v, name: state.leather } }));
    }
    var onChange = function (key) { return function () { state[key] = this.value; paint(); }; };
    for (var a = 0; a < cRadios.length; a += 1) cRadios[a].addEventListener('change', onChange('colour'));
    for (var b = 0; b < sRadios.length; b += 1) sRadios[b].addEventListener('change', onChange('size'));
    for (var d = 0; d < lRadios.length; d += 1) lRadios[d].addEventListener('change', onChange('leather'));
    // 12.10: ?d= chose another design above → paint it once so every number, the gallery and the gate match the tile
    if (state.colour !== tree.own && tree.colours[state.colour]) paint();
    // first paint only when the URL asks for another leather of THIS page's product
    try {
      var q = new URL(window.location.href).searchParams.get('variant');
      var ownSize = sizeEntry(tree.colours[tree.own]);
      if (q && ownSize && ownSize.variants) {
        for (var name in ownSize.variants) {
          var cand = ownSize.variants[name];
          if (Object.prototype.hasOwnProperty.call(ownSize.variants, name) && String(cand.id) === String(q) && cand.avail && name !== state.leather) {
            state.leather = name;
            setRadios(lRadios, name);
            paint();
            break;
          }
        }
      }
    } catch (_e) { /* no URL API */ }
  }

  /* End date (owner 10.09: "sunday gần nhất, dynamic"): the coming Sunday in Albuquerque time (today if it is
     Sunday), printed into every [data-afl-sset-ends] when the setting is the keyword `sunday`. The offer is
     framed as a weekly edition ("This week's Sunday Set"), so the date is a real edition boundary. */
  /* v4 show-don't-tell: 7-cell week strip (Mon..Sun) — past days dimmed, today ringed, the days left lit marigold,
     Sunday (the end) inked — plus "N days" copy. `todayIdx` = today's Mon(0)..Sun(6) index in the store's time zone. */
  function paintWeek(todayIdx) {
    var cells = document.querySelectorAll('[data-afl-sset-day]'); // v9: no week strip any more; days-left still painted
    for (var i = 0; i < cells.length; i++) {
      var c = cells[i], idx = parseInt(c.getAttribute('data-afl-sset-day'), 10);
      c.classList.toggle('is-past', idx < todayIdx);
      c.classList.toggle('is-today', idx === todayIdx);
      c.classList.toggle('is-left', idx >= todayIdx && idx < 6);
      c.classList.toggle('is-end', idx === 6);
    }
    var left = 6 - todayIdx;
    var dl = document.querySelectorAll('[data-afl-sset-daysleft]');
    for (var j = 0; j < dl.length; j++) dl[j].textContent = left === 0 ? 'Last day' : left + (left === 1 ? ' day' : ' days');
  }

  function paintEnds(root) {
    var chip = document.querySelector('[data-afl-sset-ends-mode]');
    if (!chip || chip.getAttribute('data-afl-sset-ends-mode') !== 'sunday') return;
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }).formatToParts(new Date());
    var get = function (t) { return (parts.find(function (p) { return p.type === t; }) || {}).value; };
    var local = new Date(get('month') + ' ' + get('day') + ', ' + get('year') + ' 12:00:00');
    paintWeek((local.getDay() + 6) % 7); // today's Mon..Sun index — BEFORE local is moved to the coming Sunday
    var add = (7 - local.getDay()) % 7; // 0 on a Sunday
    local.setDate(local.getDate() + add);
    var label = 'Sun, ' + MONTHS[local.getMonth()] + ' ' + local.getDate();
    var outs = document.querySelectorAll('[data-afl-sset-ends]');
    for (var i = 0; i < outs.length; i += 1) outs[i].textContent = label;
  }

  function cartPost(path, body) {
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {}),
    }).then(function (res) {
      if (!res.ok) throw new Error(path + ' ' + res.status);
      return res.json();
    });
  }

  function wireButton(root) {
    var cta = root.querySelector('[data-afl-sset-cta]');
    var err = root.querySelector('[data-afl-sset-error]');
    if (!cta) return;
    /* 23.09: data-items AND data-lp-key are READ AT CLICK TIME - the leather / size rows rewrite the bag's variant id
       and the gate key in place (a Small set carries its own gate). */
    function readItems() {
      try { return JSON.parse(root.getAttribute('data-items') || '[]'); } catch (_e) { return []; }
    }
    function gateProps() {
      var key = root.getAttribute('data-lp-key') || 'aina-set';
      var props = {};
      props['_afl_lp'] = key; // hidden gate the afl-set-discount function checks
      var setName = root.getAttribute('data-set-name');
      if (setName) props['Set'] = setName; // visible on every line in the drawer and at checkout (owner 10.09)
      var attrs = {};
      attrs['_afl_lp'] = key;
      return { props: props, attrs: attrs };
    }
    if (!readItems().length || !window.fetch) {
      cta.disabled = true;
      return;
    }
    var busy = false;

    /* v12 (owner 10.09 19:59: "click add to cart không có hiệu ứng loading"): one state machine for EVERY button that
       adds the set — the real CTA, the phone sticky button and the close band's proxy — 'busy' (spinner + "Adding…"),
       'added' (ink + "Added ✓"), '' (idle, original label). The label span is [data-afl-sset-label] / .afl-sset__cta-text. */
    function buttons() {
      var list = [cta];
      var extra = document.querySelectorAll('[data-afl-sset-sticky-btn], [data-afl-sset-cta-proxy]');
      for (var i = 0; i < extra.length; i += 1) list.push(extra[i]);
      return list;
    }
    function setState(state) {
      var all = buttons();
      for (var i = 0; i < all.length; i += 1) {
        var b = all[i];
        var label = b.querySelector('[data-afl-sset-label], .afl-sset__cta-text');
        if (label) {
          if (!b.__aflLabel) b.__aflLabel = label.textContent;
          label.textContent = state === 'busy' ? 'Adding…' : state === 'added' ? 'Added ✓' : b.__aflLabel;
        }
        b.classList.toggle('is-busy', state === 'busy');
        b.classList.toggle('is-added', state === 'added');
        b.disabled = state !== '';
        if (state === 'busy') b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      }
    }

    function fail() {
      busy = false;
      setState('');
      if (err) {
        err.textContent = root.getAttribute('data-error') || 'Please tap once more.';
        err.hidden = false;
      }
    }

    cta.addEventListener('click', function () {
      if (busy) return;
      busy = true;
      setState('busy');
      if (err) err.hidden = true;
      var gate = gateProps();
      var lines = readItems().map(function (it) {
        return { id: it.id, quantity: it.quantity || 1, properties: gate.props };
      });
      cartPost('/cart/update.js', { attributes: gate.attrs })
        .then(function () {
          return cartPost('/cart/add.js', { items: lines });
        })
        .then(function () {
          /* v7 (owner 10.09 14:3x): a normal add-to-cart — stay on the page, let the theme open the cart drawer
             (theme:cart:refresh → afroyla-theme-events bridge → cart-drawer auto-open, same pair as the standard
             buy box), and show ADDED on the button for a moment. No redirect to /checkout. */
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
          setState('added');
          setTimeout(function () {
            busy = false;
            setState('');
          }, 1800);
        })
        .catch(fail);
    });
  }

  /* v2 (10.09): phone sticky bar - appears once the real button has scrolled above the viewport; its
     button simply clicks the real one (one code path for the Cart API add). */
  function wireSticky(root) {
    var bar = document.querySelector('[data-afl-sset-sticky]');
    var cta = root.querySelector('[data-afl-sset-cta]');
    if (!bar || !cta) return;
    var btn = bar.querySelector('[data-afl-sset-sticky-btn]');
    if (btn) btn.addEventListener('click', function () { cta.click(); });
    var ticking = false;
    /* v11: the chat bubble (a bare fixed <button> at bottom/right 20px, z-index 2147483000 — Chatwoot/Commslayer
       widget, no class to target in CSS) sat on top of the bar's button. While the bar shows, lift every such
       bottom-right fixed button above the bar; put it back when the bar hides. */
    var lifted = [];
    function bubbles() {
      var found = [];
      var btns = document.querySelectorAll('body > button, body > div > button');
      for (var i = 0; i < btns.length; i += 1) {
        var cs = window.getComputedStyle(btns[i]);
        if (cs.position !== 'fixed' || btns[i].closest('[data-afl-sset-sticky]')) continue;
        var r = btns[i].getBoundingClientRect();
        if (r.bottom > window.innerHeight - 100 && r.right > window.innerWidth - 100) found.push(btns[i]);
      }
      return found;
    }
    function liftBubble(show) {
      if (show) {
        var h = bar.getBoundingClientRect().height || 72;
        lifted = bubbles();
        for (var i = 0; i < lifted.length; i += 1) {
          if (!lifted[i].__aflBottom) lifted[i].__aflBottom = lifted[i].style.bottom || '';
          lifted[i].style.setProperty('bottom', (h + 12) + 'px', 'important');
          lifted[i].style.transition = 'bottom 160ms ease';
        }
      } else {
        for (var j = 0; j < lifted.length; j += 1) lifted[j].style.setProperty('bottom', lifted[j].__aflBottom, lifted[j].__aflBottom ? 'important' : '');
        lifted = [];
      }
    }
    function check() {
      ticking = false;
      var above = cta.getBoundingClientRect().bottom < 0;
      /* disabled while busy/added is fine — the bar mirrors that state; hide only when the set is unavailable */
      var show = above && !cta.hasAttribute('data-afl-sset-unavailable');
      if (bar.hidden === show) { bar.hidden = !show; liftBubble(show); }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  /* v10 (10.09): any [data-afl-sset-cta-proxy] on the page (the closing band's button, sections/
     afroyla-sunday-set-close.liquid) clicks the real button — one Cart API code path, same as the sticky bar. */
  function wireProxies(root) {
    var cta = root.querySelector('[data-afl-sset-cta]');
    if (!cta) return;
    var proxies = document.querySelectorAll('[data-afl-sset-cta-proxy]');
    for (var i = 0; i < proxies.length; i += 1) {
      proxies[i].addEventListener('click', function () { if (!cta.disabled) cta.click(); });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-afl-sset]');
    for (var i = 0; i < roots.length; i += 1) {
      paintArrival(roots[i]);
      paintEnds(roots[i]);
      wireOptions(roots[i]);
      wireButton(roots[i]);
      wireSticky(roots[i]);
      wireProxies(roots[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
